import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

export type UpsellState = {
  readonly upsSavingsModalOpen: Readonly<boolean>;
};

const initialState = {
  upsSavingsModalOpen: false,
};

function reducer(state: UpsellState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.UPS_SAVINGS_MODAL_TOGGLE:
      return {
        ...state,
        upsSavingsModalOpen: !state.upsSavingsModalOpen,
      };
    default:
      return state;
  }
}

export default reducer;
